import script from "./OriginalThemeProvider.vue?vue&type=script&lang=js&setup=true"
export * from "./OriginalThemeProvider.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__